import "./MapFilters.scss"
import { Button, IconButton, Typography } from "@mui/material"
import { SVGIcon } from "../../../../shared/components/SVGIcon/SVGIcon";
import { IMapFilter } from "../../map-models";
import { useEffect, useState } from "react";
import TuneIcon from '@mui/icons-material/Tune';
import { AdvancedFiltersModal } from "../AdvancedFiltersModal/AdvancedFiltersModal";
import { BaseMapFilterEnum } from "../../../../shared/models/map_models";
import ChipFilterInput from "../ChipFilterInput/ChipFilterInput";
import MultiSelectFilterInput from "../MultiSelectFilterInput/MultiSelectFilterInput";
import NumberRangeFilter from "../NumberRangeFilter/NumberRangeFilter";
import CheckboxFilterInput from "../CheckboxFilterInput/CheckboxFilterInput";

interface IFilterIconProps {
    filter: IMapFilter
    handleFilterClick: (filter: IMapFilter) => void
}


const FilterIcon = (props: IFilterIconProps) => {

    const svgName = props.filter.name.toLowerCase().replace(" ", "_")

    return (
        <div className="filter-icon">
            <Button
                className={props.filter.value === true ? "selected-filter" : ""} 
                variant={props.filter.value === true ? "contained": "outlined"}
                startIcon={
                    <SVGIcon iconName={svgName}/>
                }
                onClick={() => props.handleFilterClick(props.filter)}
                disabled={props.filter.disabled}
            >
                <Typography sx={{color: "text.primary"}}>{props.filter.name}</Typography>
            </Button>
        </div>
    )
}

interface IMapFilterProps {
    layerId: number,
    filters: Array<IMapFilter>
    updateFilter: (filter: IMapFilter) => void
}

const MapFilters = (props: IMapFilterProps) => {

    const [filters, setFilters] = useState<Array<IMapFilter>>([])
    const [advancedFilters, setAdvancedFilters] = useState<Array<IMapFilter>>([])
    const [showAdvancedFilters, setShowAdvancedFilters] = useState(false)
    const [hasActiveFilter, setHasActiveFilter] = useState(false)

    const toggleAdvancedFiltersModal = () => {
        setShowAdvancedFilters(!showAdvancedFilters)
    }
    useEffect(() => {
        const mainFilters = props.filters.filter((x) => x.layer_id === props.layerId && x.placement === 'main')
        const advFilters = props.filters.filter((x) => x.layer_id === props.layerId && x.placement === 'advanced')
        setFilters(mainFilters || [])
        setAdvancedFilters(advFilters)

        const activeAdvFilters = advFilters.filter((x) => x.value !== '' && x.value !== false)

        if(activeAdvFilters.length > 0)
            setHasActiveFilter(true)
        else
            setHasActiveFilter(false)
        
    }, [props])

    const radioFilterSelected = (filter: IMapFilter) => {
        filter.value = !filter.value
        props.updateFilter(filter)
    }

    const handleFilterValueChanged = (filter: IMapFilter, newValue: string | boolean) => {
        if(filter.type === BaseMapFilterEnum.RADIO)
            radioFilterSelected(filter)
        else {
            filter.value = newValue
            props.updateFilter(filter)
        }
    }

    return (
        <div className="filters-container">
            {filters.map((filter, i) => {
                return (
                    <>
                        {filter.type === BaseMapFilterEnum.RADIO &&
                            <div key={i} className="filter-icon-wrapper">
                                <FilterIcon 
                                    filter={filter}
                                    handleFilterClick={() => radioFilterSelected({...filter})}
                                />
                            </div>
                        }
                        {filter.type === BaseMapFilterEnum.CHIP &&
                            <div className="chip-filter-wrapper">
                                <ChipFilterInput 
                                    label={filter.name}
                                    value={typeof filter.value === 'string' ? filter.value : ""}
                                    valueChanged={(newValue) => handleFilterValueChanged({...filter}, newValue)}
                                />
                            </div>
                        }
                        {filter.type === BaseMapFilterEnum.MULTISELECT &&
                            <div>
                                <MultiSelectFilterInput
                                    label={filter.name}
                                    value={typeof filter.value === 'string' ? filter.value : ""}
                                    valueChanged={(newValue) => handleFilterValueChanged({...filter}, newValue)}
                                    options={filter.options || []}
                                />
                            </div>
                        }
                        {filter.type === BaseMapFilterEnum.NUMBER_RANGE &&
                            <div className="number-range-filter">
                                <NumberRangeFilter 
                                    label={filter.name}
                                    value={typeof filter.value === 'string' ? filter.value : ""}
                                    valueChanged={(newValue) => handleFilterValueChanged({...filter}, newValue)}
                                    min_value={filter.min_value}
                                    max_value={filter.max_value}
                                />
                            </div>

                        }
                        {filter.type === BaseMapFilterEnum.CHECKBOX &&
                            <div className="checkbox-filter-wrapper">
                                <CheckboxFilterInput 
                                    label={filter.name}
                                    value={typeof filter.value === 'string' ? filter.value === '' ? null : filter.value === 'true' : filter.value }
                                    valueChanged={(newValue) =>  handleFilterValueChanged({...filter}, newValue)}
                                />
                            </div>
                        }
                    </>
                )
            })}
            {advancedFilters.length > 0 &&
                <div className="filter-icon-wrapper">
                    <IconButton onClick={toggleAdvancedFiltersModal}>
                        <TuneIcon 
                            sx={{color: (theme) => hasActiveFilter ? theme.palette.info.light : theme.palette.text.primary}}
                        />
                    </IconButton>
                </div>
            }
            <AdvancedFiltersModal 
                showModal={showAdvancedFilters}
                toggleModal={toggleAdvancedFiltersModal}
                filters={advancedFilters}
                filterValueChanged={(filter, newValue) => handleFilterValueChanged({...filter}, newValue)}
            />
        </div>
    )
}

export default MapFilters